import { render, staticRenderFns } from "./PlayerCarousel.vue?vue&type=template&id=d0dcc728&scoped=true"
import script from "./PlayerCarousel.vue?vue&type=script&lang=js"
export * from "./PlayerCarousel.vue?vue&type=script&lang=js"
import style0 from "./PlayerCarousel.vue?vue&type=style&index=0&id=d0dcc728&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0dcc728",
  null
  
)

export default component.exports